import { toTypeScript } from '@angular/compiler';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { App, LoadingController, NavController } from 'ionic-angular';
import { of } from 'rxjs/observable/of';
import { CategoriesProvider, CategoryModel } from '../../../../providers/categories/categories';
import { EventDetailsModel, EventProvider } from '../../../../providers/event/event';
import { SessionProvider } from '../../../../providers/session/session';
import { MyPicsListModel, PrivateProfile, UserProvider } from '../../../../providers/user/user';
import { BackgroundModel, SinleValueModel, TextValueModel, ValueProvider } from '../../../../providers/value/value';
import { PrivateProfilePage } from '../../../me/settings/private-profile/private-profile';
import { QRCodePage } from '../../../me/qrcode/qrcode';

@Component({
  selector: 'page-event-person-information',
  templateUrl: 'event-person-information.html'
})
export class EventPersonInformationPage {
  @Input("event") event: EventDetailsModel;
  @Input("event-tabs-instance") instance: any;
  accountInformation: boolean = false;
  createAccount: boolean = false;

  profileBackup: PrivateProfile;
  profile: PrivateProfile;
  titles: SinleValueModel[] = [];
  types: SinleValueModel[] = [];
  categories: CategoryModel[] = [];
  photos: MyPicsListModel[] = [];
  countries: TextValueModel[] = [];
  backgrounds: BackgroundModel[] = [];
  // birthDay: string;
  password: string = "";
birthDateISO = "";
  isFormFilled:boolean=false;

  constructor(
    private valueService: ValueProvider,
    private sessionService: SessionProvider,
    private translate: TranslateService,
    private loadingCtrl: LoadingController,
    private categoryService: CategoriesProvider,
private eventService: EventProvider,
    private app: App,
    private userService: UserProvider) {
    this.initAccountData();
  }

  initAccountData() {
    if (this.sessionService.isLoged) {
      let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
      loader.present();
      Promise.all([
        this.valueService.getProfileTitles(),
        this.valueService.getProfileTypes(),
        this.valueService.getCountries(),
        this.categoryService.getProfileCategoires(),
        this.userService.getMyPhotos(),
        this.valueService.getProfileBackgrounds(),
        this.userService.getPrivateProfile()
      ]).then(values => {
        this.titles = values[0];
        this.types = values[1];
        this.countries = values[2];
        this.categories = values[3];
        this.photos = values[4];
        this.backgrounds = values[5];
        this.profile = values[6];
        this.profile.country = this.profile.country.length > 0 ? this.profile.country : "DE";
        this.birthDateISO = this.profile.birthday > 0 ? new Date(this.profile.birthday).toISOString() : "";
        // this.birthDay = this.profile.birthday == 0? "" : new Date(this.profile.birthday).toISOString();
      }).then(() => {
        this.accountInformation = true;
        loader.dismiss();
      })
    }
  }

  nextPage() {
    this.profile.birthday = new Date(this.birthDateISO).getTime();
    this.userService.updateProfile(this.profile);
    if(this.instance.eventPrice > 0 || this.instance.event.price>0){
      this.instance.detailPage = "payment";
    }else{
      this.onPayment(true);
    }
  }

  checkForm() {
    this.isFormFilled = this.profile.anrede.length >0 &&
        this.profile.surName.length>0 &&
        this.profile.forName.length>0 &&
        this.profile.zip.length>0 &&
        this.profile.city.length>0 &&
        this.profile.country.length>0 &&
        this.profile.homeStreet.length>0 &&
        this.profile.homeStreetNo.length>0 &&
        this.birthDateISO.length>0
    if(this.profile.city.length>0){
      this.isFormFilled = true
    }
  }

onPayment(result) {
    console.log('onPayment: ' + result);
    if (result) {
      this.sessionService.getToken(false, false).then(token => {
      this.eventService.savePaymentWithToken(this.event.id + "", token).then(() => {
          this.instance.disablePayment();
          this.instance.detailPage = "details";
          this.eventService.getQRCode(token, this.event.id).then(qrcode => {
              (this.app.getActiveNav() as NavController).push(QRCodePage, { qrcode: qrcode.content });
          });
        })
        .catch((err) => console.error(err));
      });
    }
  }

  ionViewWillEnter(){
    console.log("entered!");
  }

  ngOnInit(){
    console.log("entered!");

  }
}


// WEBPACK FOOTER //
// /src/pages/event/details/event-person-information/event-person-information.ts